import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-79794e6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headerCont" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: './img/logo_hppc.png',
    alt: "和平電力"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "和平電力", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  class: "navPC",
  ref: "navPC"
}
const _hoisted_7 = { class: "menuGroup" }
const _hoisted_8 = {
  key: 0,
  class: "tit"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "tit titGap" }
const _hoisted_11 = { class: "subMenu" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_15 = {
  class: "navPcEndBorder",
  ref: "navPcEndBorder"
}
const _hoisted_16 = { class: "navPhone" }
const _hoisted_17 = { class: "hamburOpen fa-solid fa-bars" }
const _hoisted_18 = {
  class: "navPhoneBack",
  ref: "navPhoneBack"
}
const _hoisted_19 = {
  class: "menuGroup",
  ref: "menuGroup"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "hamburClose fa-solid fa-xmark" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down arrow" }, null, -1))
const _hoisted_24 = ["idx"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down arrow" }, null, -1))
const _hoisted_26 = { class: "subMenu" }
const _hoisted_27 = ["href"]
const _hoisted_28 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        class: "logoCont",
        href: _ctx.urlPath.index
      }, _hoisted_5, 8, _hoisted_2),
      _createElementVNode("nav", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (row, idx) => {
            return (_openBlock(), _createElementBlock("li", { key: idx }, [
              (row.subTitStage1.length==0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("a", {
                      href: _ctx.setUrl(row.pathName)
                    }, _toDisplayString(row.tit), 9, _hoisted_9)
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(row.tit), 1),
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.subTitStage1, (row2, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "subTit",
                          key: idx
                        }, [
                          (row2.type=='outerLink')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                target: "_blank",
                                href: row2.pathName
                              }, _toDisplayString(row2.subTit), 9, _hoisted_12))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: _ctx.setUrl(row2.pathName)
                              }, _toDisplayString(row2.subTit), 9, _hoisted_13))
                        ]))
                      }), 128))
                    ])
                  ], 64))
            ]))
          }), 128))
        ]),
        _hoisted_14
      ], 512),
      _createElementVNode("div", _hoisted_15, null, 512),
      _createElementVNode("nav", _hoisted_16, [
        _createElementVNode("div", {
          class: "hamburger",
          ref: "hamburger",
          togglePhoneMenuGroupStatus: "false",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePhoneMenuGroup && _ctx.togglePhoneMenuGroup(...args)))
        }, [
          _createVNode(_Transition, { name: "hamburOpenClose" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("i", _hoisted_17, null, 512), [
                [_vShow, _ctx.isPhoneMenuShow]
              ])
            ]),
            _: 1
          })
        ], 512),
        _createVNode(_Transition, { name: "navPhoneBackShowHidden" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_18, null, 512), [
              [_vShow, _ctx.isNavPhoneBackShow]
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", {
            class: "hamburgerX",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePhoneMenuGroup && _ctx.togglePhoneMenuGroup(...args)))
          }, _hoisted_21),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (row, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "menu",
              key: idx
            }, [
              (row.subTitStage1.length==0)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "tit",
                    href: _ctx.setUrl(row.pathName)
                  }, [
                    _createTextVNode(_toDisplayString(row.tit) + " ", 1),
                    _hoisted_23
                  ], 8, _hoisted_22))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", {
                      class: "tit",
                      togglePhoneSubMenuStatus: "false",
                      idx: idx,
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePhoneSubMenu && _ctx.togglePhoneSubMenu(...args)))
                    }, [
                      _createTextVNode(_toDisplayString(row.tit) + " ", 1),
                      _hoisted_25
                    ], 8, _hoisted_24),
                    _createElementVNode("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.subTitStage1, (row2, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "subTit",
                          key: idx
                        }, [
                          (row2.type=='outerLink')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                target: "_blank",
                                href: row2.pathName
                              }, _toDisplayString(row2.subTit), 9, _hoisted_27))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: _ctx.setUrl(row2.pathName)
                              }, _toDisplayString(row2.subTit), 9, _hoisted_28))
                        ]))
                      }), 128))
                    ])
                  ], 64))
            ]))
          }), 128))
        ], 512)
      ])
    ])
  ]))
}